import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "./Person";

export default class Receipt extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			type: this.isNull(props.Type) ? 0 : props.Type,
			factorId: this.isNull(props.FactorId) ? this.defaultGuid() : props.FactorId,
			refreshAfterSave: this.isNull(props.RefreshAfterSave) ? true : props.RefreshAfterSave,
			data: null,
			loading: true,
			version: this.uuidv4(),
			version2: this.uuidv4()
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.httpPost("api/v1/receipt/get", {
			id: this.state.id,
			type: this.state.type,
			factorId: this.state.factorId
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.setState({
						data: data,
						loading: false
					});
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	save() {
		if (this.isBlank(this.state.data.record.moeinCode)) this.state.data.record.moeinCode = 0;
		if (this.isBlank(this.state.data.record.tafsilCode)) this.state.data.record.tafsilCode = 0;

		var receiptItems = Object.assign([], this.state.data.receiptItems);
		receiptItems.forEach(item => {
			if (!this.isBlank(item.chequeDate)) item.chequeDate = this.convertMomentToDb(item.chequeDate);
		});

		this.httpPost("api/v1/receipt/save", {
			id: this.state.data.record.id,
			organizationId: this.state.data.global.company.id,
			description: this.state.data.record.description,
			note: this.state.data.record.note,
			type: this.state.data.record.type,
			date: this.convertMomentToDb(this.state.data.record.date),
			moeinCode: this.state.data.record.moeinCode,
			tafsilCode: this.state.data.record.tafsilCode,
			objectType: this.state.data.record.objectType,
			personId: this.state.data.record.personId,
			factorId: this.state.data.record.factorId,
			receiptItems,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("رسید با موفقیت ذخیره شد");
					if (this.state.refreshAfterSave) this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	getBlankRow(objectType,chequeDate=null) {
		return {
			id: this.uuidv4(),
			objectType:objectType,
			stuffId: this.defaultGuid(),
			price: 0,
			price2: 0,
			currencyRate: this.state.data.currencyRate,
			description: '',
			fishNumber: '',
			chequeInfoId: this.defaultGuid(),
			chequeId: this.defaultGuid(),
			cashDeskId: null,
			bankAccountId: this.defaultGuid(),
			chequeNumber: 0,
			chequeDate: chequeDate,
			bankName: '',
			branch: '',
			personId: null
		};
	}
	addNewNagdRow() {
		var v = this.getBlankRow(1);
		v.cashDeskId = this.defaultGuid();
		this.state.data.receiptItems.push(v);
		this.setState({ data: this.state.data });
	}
	addNewChequeRow() {
		var v = this.getBlankRow(3,this.state.data.record.date);
		this.state.data.receiptItems.push(v);
		this.setState({ data: this.state.data });
	}
	addNewFishRow() {
		var v = this.getBlankRow(2);
		this.state.data.receiptItems.push(v);
		this.setState({ data: this.state.data });
	}
	removeRow(id) {
		var t = [];
		this.state.data.receiptItems.forEach(i => {
			if (i.id != id) {
				t.push(i);
			}
		});
		this.state.data.receiptItems = t;
		this.updateFormula();
	}
	setItemValue(f, e, id) {
		this.state.data.receiptItems.forEach(i => {
			if (i.id === id) {
				i[f] = e;

				if (f == "price") {
					i.price2 = this.FixedPointNumber(parseInt(i.price) / i.currencyRate, 2);
					this.state.version2 = this.uuidv4();
				}
				if (f == "price2") {
					i.price = this.FixedPointNumber(parseInt(i.price2) * i.currencyRate, 0);
					this.state.version = this.uuidv4();
				}
			}
		});
		this.updateFormula();
	}
	updateFormula() {
		var t = 0;
		this.state.data.receiptItems.forEach(i => {
			if (!this.isBlank(i.price)) t += i.price;
		});
		this.state.data.record.total = t;
		this.setState({ data: this.state.data });
	}
	renderNagdBox(item) {
		return <div className="row mr-10 acc-pay-get-box" style={{ "background-color": "#337AB7", "border": "1px solid #337AB7", "position": "relative" }} >
			<div className="col-sm-1 text-center" style={{ "min-height": "58px", "display": "table" }} >
				<div style={{ "display": "table-cell", "vertical-align": "middle" }} >وجه نقد</div>
			</div>
			<div className="col-sm-11 pd-10" style={{ "padding-top": "15px", "background-color": "white", "color": "rgb(34, 34, 34)" }} >
				<div className="row" style={{ "margin-left": "5px" }}>
					<label className="col-sm-1 text-left">مبلغ<span className="red">*</span>:</label>
					<div key={this.state.version + item.id +"_price" }>
						<input defaultValue={item.price} onChange={e => this.setItemValue('price', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>
					<label className="col-sm-1 text-left">نرخ ارز<span className="red">*</span>:</label>
					<div>
						<input disabled="disabled" value={item.currencyRate} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>
					<label className="col-sm-1 text-left">مبلغ ارزی<span className="red">*</span>:</label>
					<div key={this.state.version2 + item.id + "_price2"}>
						<input defaultValue={item.price2} onChange={e => this.setItemValue('price2', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>
					<div style={{ "clear": "both", "padding-top": "10px" }}>
					<label className="col-sm-1 text-left">صندوق<span className="red">*</span>:</label>
					<div className="col-sm-2" style={{ "padding": "0" }}>
						<SelectAsync
							defaultValue={item.cashDeskId != this.defaultGuid() ? [{ value: item.cashDeskId, label: item.cashDeskName }] : null}
							isMulti={false}
							placeholder="انتخاب صندوق"
							defaultOptions
							loadOptions={this.loadCashdesksOptions}
							onChange={e => this.setItemValue('cashDeskId', e.value, item.id) }
						/>
						</div>
					</div>
					<div style={{ "clear": "both", "padding-top": "10px" }}>
						<label className="col-sm-1 text-left">شرح:</label>
						<div>
							<input defaultValue={item.description} onChange={e => this.setItemValue('description',e.target.value,item.id)} autocomplete="off" type="text" className="description col-sm-11 form-control input-sm" />
						</div>
					</div>
				</div>
			</div>
			<a onClick={e => this.removeRow(item.id)} className="hand" style={{ "width": "10px", "height": "20px", "position": "absolute", "color": "#3379b6", "left": "0", "cursor": "pointer", "top": "0" }}>x</a>
		</div>
	}
	renderFishBox(item) {
		return <div className="row mr-10 acc-pay-get-box" style={{ "background-color": "#9e32bd", "border": "1px solid #9e32bd", "position": "relative" }}>
			<div className="col-sm-1 text-center" style={{ "min-height": "58px", "display": "table" }}>
				<div style={{ "display": "table-cell", "vertical-align": "middle" }}>فیش بانکی</div>    </div>
			<div className="col-sm-11 pd-10" style={{ "padding-top": "15px", "background-color": "white", "color": "rgb(34, 34, 34)" }}>
				<div className="row" style={{ "margin-left": "5px" }}>
					<label className="col-sm-1 text-left">مبلغ<span className="red">*</span>:</label>
					<div key={this.state.version + item.id + "_price"}>
						<input defaultValue={item.price} onChange={e => this.setItemValue('price', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>
					<label className="col-sm-1 text-left">نرخ ارز<span className="red">*</span>:</label>
					<div>
						<input disabled="disabled" value={item.currencyRate} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>
					<label className="col-sm-1 text-left">مبلغ ارزی<span className="red">*</span>:</label>
					<div key={this.state.version2 + item.id + "_price2"}>
						<input defaultValue={item.price2} onChange={e => this.setItemValue('price2', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>
					<div style={{ "clear": "both", "padding-top": "10px" }}>
					<label className="col-sm-2 text-left">شماره فیش/ارجاع:</label>
					<div>
						<input defaultValue={item.fishNumber} onChange={e => this.setItemValue('fishNumber', e.target.value, item.id)} autocomplete="off" type="text" className="fish_number col-sm-2 form-control input-sm" /></div>
					<label className="col-sm-2 text-left">بانک<span className="red">*</span>:</label>
					<div style={{ "padding": "0" }} className="col-sm-2">
						<SelectAsync
							defaultValue={item.bankAccountId != this.defaultGuid() ? [{ value: item.bankAccountId, label: item.bankAccountName }] : null}
							isMulti={false}
							placeholder="انتخاب بانک"
							defaultOptions
							loadOptions={this.loadBankAccountsOptions} 
							onChange={e => this.setItemValue('bankAccountId', e.value, item.id)}
						/>
						</div>
					</div>
					<div style={{ "clear": "both", "padding-top": "10px" }}>
						<label className="col-sm-1 text-left">شرح:</label>
						<div>
							<input defaultValue={item.description} onChange={e => this.setItemValue('description', e.target.value, item.id)} autocomplete="off" type="text" className="description col-sm-11 form-control input-sm" /></div>
					</div>
				</div>
			</div>
			<a onClick={e => this.removeRow(item.id)} className="hand" style={{ "width": "10px", "height": "20px", "position": "absolute", "color": "#9e32bd", "left": "0", "cursor": "pointer", "top": "0" }}>x</a>
		</div>
	}
	renderChequeBox(item) {
		return <div className="row mr-10 acc-pay-get-box " style={{ "background-color": "#bd6532", "border": "1px solid #bd6532", "position": "relative" }}>
			<div className="col-sm-1 text-center" style={{ "min-height": "85px", "display": "table" }}>
				<div style={{ "display": "table-cell", "vertical-align": "middle" }}>چـک</div>
			</div>
			<div className="col-sm-11 pd-10" style={{ "padding-top": "15px", "background-color": "white", "color": "rgb(34, 34, 34)" }}>
				<div className="row m-b-5" style={{ "margin-left": "5px" }}>
					<label className="col-sm-1 text-left">مبلغ<span className="red">*</span>:</label>
					<div key={this.state.version + item.id + "_price"}>
						<input defaultValue={item.price} onChange={e => this.setItemValue('price', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>
					<label className="col-sm-1 text-left">نرخ ارز<span className="red">*</span>:</label>
					<div>
						<input disabled="disabled" value={item.currencyRate} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>
					<label className="col-sm-1 text-left">مبلغ ارزی<span className="red">*</span>:</label>
					<div key={this.state.version2 + item .id + "_price2"}>
						<input defaultValue={item.price2} onChange={e => this.setItemValue('price2', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
					</div>
					<div style={{ "clear": "both", "padding-top": "10px" }}>
					<label className="col-sm-2 text-left">شماره چک<span className="red">*</span>:</label>
					{this.state.data.record.type === 1 && <input defaultValue={item.chequeNumber} onChange={e => this.setItemValue('chequeNumber', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="cheque_number col-sm-2 form-control input-sm" />}
					{this.state.data.record.type === 2 && item.bankAccountId != this.defaultGuid() && <div className="col-sm-2"><SelectAsync
						defaultValue={item.chequeNumber > 0 ? [{ value: item.chequeId, label: item.chequeNumber }] : null}
						isMulti={false}
						placeholder="انتخاب چک"
						defaultOptions
						loadOptions={(inputValue, callback) => this.loadChequeNumbersOptions(inputValue, callback, item.bankAccountId)}
						onChange={e => {
							this.setItemValue('chequeId', e.id, item.id);
							this.setItemValue('chequeNumber', e.number, item.id);
						}
						}
					/></div>}
					<label className="col-sm-2 text-left">تاریخ چک<span className="red">*</span>:</label>
					<DatePicker
						inputReadOnly={true}
						className="form-control input-sm persian-date col-sm-2"
						placeholder={"تاریخ"}
						isGregorian={false}
						showTodayButton={true}
						timePicker={false}
						onChange={(e) => { this.setItemValue('chequeDate', e, item.id) }}
						value={this.getFormatedDateForDatePicker(item.chequeDate)}
						/>
					</div>
				</div>
				<div className="row" style={{ "margin-left": "5px" }}>
					<label className="col-sm-1 text-left">بانک:</label>
					{this.state.data.record.type === 1 && <div className="col-sm-3">
						<input defaultValue={item.bankName} onChange={e => this.setItemValue('bankName', e.target.value, item.id)} autocomplete="off" type="text" className="cheque_bank col-sm-3 form-control input-sm" />
					</div>}
					{this.state.data.record.type === 2 && <div className="col-sm-3"><SelectAsync
						defaultValue={item.bankAccountId != this.defaultGuid() ? [{ value: item.bankAccountId, label: item.bankAccountName }] : null}
						isMulti={false}
						placeholder="انتخاب بانک"
						defaultOptions
						loadOptions={this.loadBankAccountsOptions}
						onChange={e => this.setItemValue('bankAccountId', e.value, item.id)}
						onChange={e => {
							this.setItemValue('bankAccountId', e.value, item.id);
							this.setItemValue('bankAccountName', e.label, item.id);
						}
						}
					/>
					</div>}
					{this.state.data.record.type === 1 && <label className="col-sm-2 text-left">شعبه:</label>}
					{this.state.data.record.type === 1 && <div>
						<input defaultValue={item.branch} onChange={e => this.setItemValue('branch', e.target.value, item.id)} autocomplete="off" maxlength="50" type="text" className="cheque_branch col-sm-2 form-control input-sm" />
					</div>}
					<div style={{ "clear": "both", "padding-top": "10px" }}>
						<label className="col-sm-1 text-left">شرح:</label>
						<div>
							<input defaultValue={item.description} onChange={e => this.setItemValue('description', e.target.value, item.id)} autocomplete="off" type="text" className="description col-sm-11 form-control input-sm" /></div>
					</div>
				</div>
			</div>
			<a onClick={e => this.removeRow(item.id)} className="hand" style={{ "width": "10px", "height": "20px", "position": "absolute", "color": "#bd6432", "left": "0", "cursor": "pointer", "top": "0" }}>x</a>
		</div>
	}
	changeObjectType(e) {
		this.state.data.record.objectType = e;
		this.setState({ data: this.state.data });
	}
	setPerson(e) {
		if (e.value == -1) {
			this.state.data.record.personId = this.defaultGuid();
			this.state.data.record.personName = '';
			this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.state.data.record.personId = e.value;
		this.state.data.record.personName = e.label;
		this.setState({ data: this.state.data });
	}
	setMoein(e) {
		this.state.data.record.moeinCode = e.value;
		this.state.data.record.moeinName = e.label;
	}
	setTafsil(e) {
		this.state.data.record.tafsilCode = e.value;
		this.state.data.record.tafsilName = e.label;
	}
	renderForm() {
		return <div className="modal fade in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e=>this.closeMe() }></div>
			<div className="modal-dialog modal-lg" role="document" style={{ "width": "96%" }}>
				<div className="modal-content">
					<div className="modal-body" id="DocumentModalViewerContent" style={{ "padding": "0px" }}>
						<div className="row center-block">
							<div className="center-block" style={{ "max-width": "none" }} >
								<div className="panel-body">
									<div className="row mr-t-5">
										{/*<div className="col-sm-2">*/}
										{/*	{this.state.data.record.factorId != this.defaultGuid() && !this.isNull(this.state.data.record.factorId) && <div className="form-group">*/}
										{/*		{this.state.data.record.type === 1 ?*/}
										{/*			<label>دریافت بابت فاکتور شماره: {this.state.data.factor.number}</label>*/}
										{/*			:*/}
										{/*			<label>پرداخت بابت فاکتور شماره: {this.state.data.factor.number}</label>*/}
										{/*		}*/}
										{/*	</div>}*/}
										{/*	{(this.state.data.record.factorId == this.defaultGuid() || this.isNull(this.state.data.record.factorId)) &&*/}
										{/*		<div className="form-group">*/}
										{/*			{this.state.data.record.type === 1 ?*/}
										{/*				<label>دریافت</label>*/}
										{/*				:*/}
										{/*				<label>پرداخت </label>*/}
										{/*			}*/}
										{/*			{this.state.data.record.type === 1 ? <div>*/}
										{/*					<button onClick={e => this.changeObjectType(1)} type="button" className={"btn btn-default btn-sm" + (this.state.data.record.objectType === 1 ? " btn-primary" : "")}>از شخص</button>*/}
										{/*					<button onClick={e => this.changeObjectType(2)} type="button" className={"btn btn-default btn-sm" + (this.state.data.record.objectType === 2 ? " btn-primary" : "")}>سایر</button>*/}
										{/*				</div>*/}
										{/*				:*/}
										{/*				<div>*/}
										{/*					<button onClick={e => this.changeObjectType(1)} type="button" className={"btn btn-default btn-sm" + (this.state.data.record.objectType === 1 ? " btn-primary" : "")}>به شخص</button>*/}
										{/*					<button onClick={e => this.changeObjectType(2)} type="button" className={"btn btn-default btn-sm" + (this.state.data.record.objectType === 2 ? " btn-primary" : "")}>سایر</button>*/}
										{/*				</div>*/}
										{/*			}*/}
										{/*		</div>}*/}
										{/*</div>*/}

										{this.state.data.record.objectType === 1 && <div className="col-sm-4">
											<div className="form-group">
												<label>شخص<span className="red">*</span></label>
												<SelectAsync
													value={this.state.data.record.personId != this.defaultGuid() ? [{ value: this.state.data.record.personId, label: this.state.data.record.personName }] : null}
													isMulti={false}
													placeholder="انتخاب شخص"
													defaultOptions
													loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1)}
													onChange={e => this.setPerson(e)}
											/>
										</div>
										</div>}

										{this.state.data.record.objectType === 2 && <div className="col-sm-4">
											<div className="form-group">
												<label>معین<span className="red">*</span></label>
												<SelectAsync
													style={{ "width": "100%" }}
													defaultValue={this.state.data.record.moeinCode > 0 ? [{ value: this.state.data.record.moeinCode, label: this.state.data.record.moeinName }] : null}
													isMulti={false}
													placeholder="انتخاب حساب معین"
													defaultOptions
													loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
													onChange={e => this.setMoein(e)}
												/>
											</div>
										</div>}
										{this.state.data.record.objectType === 2 && <div className="col-sm-4">
											<div className="form-group">
												<label>تفصیلی<span className="red">*</span></label>
												<SelectAsync
													style={{ "width": "100%" }}
													defaultValue={this.state.data.record.tafsilCode > 0 ? [{ value: this.state.data.record.tafsilCode, label: this.state.data.record.tafsilName }] : null}
													isMulti={false}
													placeholder="انتخاب حساب تفصیل"
													defaultOptions
													loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, this.state.data.record.moeinCode == null ? 0 : this.state.data.record.moeinCode)}
													onChange={e => this.setTafsil(e)}
												/>
											</div>
										</div>}
									</div>
									<div className="row mr-t-10">
										<div className="col-sm-9">
											<div className="form-group">
												<label>شرح<span className="red">*</span></label>
												<textarea defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} rows="2" style={{ "height": "52px" }} className="form-control input-smng-touched" maxlength="200" placeholder="شرح ..."></textarea>
											</div>
										</div>
										<div className="col-sm-3">
											<div className="form-group">
												<label>تاریخ</label>
												<DatePicker
													inputReadOnly={true}
													className="form-control input-sm persian-date"
													placeholder={"تاریخ"}
													isGregorian={false}
													showTodayButton={true}
													timePicker={false}
													onChange={(e) => { this.state.data.record.date = e }}
													value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-sm-12">
											<div className="btn-group" role="group">
												<button type="button" className="btn btn-default btn-sm hand" onClick={e => this.addNewNagdRow()}>
													<span className="fa fa-plus"></span>&nbsp;
													افزودن نقدی
												</button>
												<button type="button" className="btn btn-default btn-sm hand" onClick={e => this.addNewFishRow()}>
													<span className="fa fa-plus"></span>&nbsp;
													افزودن فیش بانکی
												</button>
												<button type="button" className="btn btn-default btn-sm hand" onClick={e => this.addNewChequeRow()}>
													<span className="fa fa-plus"></span>&nbsp;
													افزودن چک
												</button>
											</div>
										</div>
									</div>
									<div className="separator1 mr-t-10">
										{this.state.data.receiptItems.map(m => [
											m.objectType === 1 && this.renderNagdBox(m),
											m.objectType === 2 && this.renderFishBox(m),
											m.objectType === 3 && this.renderChequeBox(m)
										])}
									</div>
									<div className="row mr-t-10">
										<div className="col-sm-12">
											<div className="form-group">
												<label>یادداشت</label>
												<textarea defaultValue={this.state.data.record.note} onChange={e => this.state.data.record.note = e.target.value} rows="2" style={{ "height": "52px" }} className="form-control input-smng-touched" maxlength="200" placeholder="یادداشت ..."></textarea>
											</div>
										</div>
									</div>
									<div className="row mr-t-5" style={{ "padding-left": "15px" }} >
										<div className="col-md-8">
											<button onClick={e => this.save()} className="btn btn-success btn-sm" style={{ "width": "80px" }}>ثبت</button>
											{this.state.data.record.id != this.defaultGuid() && <button type="button" className="mr-10 btn btn-danger">حذف </button>}
											<button type="button" className="mr-10 btn btn-default btn-smoke" onClick={e => this.closeMe()}>انصراف </button>
										</div>
										<div className="col-md-4">
											<div className="row text-left" style={{ "border-bottom": "1px solid rgb(69, 69, 69)" }} >
												<div className="col-xs-4 h5 txt-bold">جمع <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
												<div className="col-xs-7 h5 txt-bold" id="invoicePayGetItemTotal_recieptPayGetItemBox">{this.money(this.state.data.record.total)} {this.state.data.global.company.currencyUnit}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}